import { Injectable } from '@angular/core';
import { ConfigService } from '../../../shared/config/config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  Property,
  PropertyManagerComplianceData,
  PropertyManagerInterestRateData,
  RequestPropertiesViewModel
} from '../models/property.model';

@Injectable()
export class PropertyService {
  private config;

  constructor(
    private configService: ConfigService,
    private http: HttpClient) {
    this.config = this.configService.getConfig()!;
  }

  getProperties(model: RequestPropertiesViewModel): Observable<Property[]> {
    return this.http.get<Property[]>(`${this.config.securityDepositBaseUrl}/manager/Properties`,
      { params: model as any });
  }

  getPropertiesCompliance(model: RequestPropertiesViewModel): Observable<PropertyManagerComplianceData[]> {
    return this.http.get<PropertyManagerComplianceData[]>(`${this.config.securityDepositBaseUrl}/manager/Properties/compliance`,
      { params: model as any });
  }

  getPropertiesInterestRates(model: RequestPropertiesViewModel): Observable<PropertyManagerInterestRateData[]> {
    return this.http.get<PropertyManagerInterestRateData[]>(`${this.config.securityDepositBaseUrl}/manager/Properties/interest-rates`,
      { params: model as any });
  }
}
